/**
 * Notification "View" links for LR Direct dispatch events.
 *
 * The app routes are:
 *   Shipper bid room (bids/award)  →  /lr-direct/live/:id
 *   Shipper tracker (post-award)   →  /lr-direct/load/:id           (singular)
 *   Broker dispatch page           →  /lr-direct/dispatches/won/:id
 *
 * Historic notify calls used the plural `/lr-direct/loads/:id` — that
 * route does not exist and lands on 404. Always use these helpers.
 *
 * Pre-award notifications (new bid, bid updated) must use
 * `shipperBidRoomLink`; dispatch/tracking events use `shipperLoadLink`.
 * The tracker also redirects an owner to the bid room while the load is
 * still pre-award, so a stale link can't strand the shipper.
 */

export const shipperLoadLink = (loadId: string): string =>
  `/lr-direct/load/${loadId}`;

export const shipperBidRoomLink = (loadId: string): string =>
  `/lr-direct/live/${loadId}`;

export const brokerDispatchLink = (loadId: string): string =>
  `/lr-direct/dispatches/won/${loadId}`;

/**
 * Pick the right link for a given notification recipient. If the recipient
 * is the shipper (load owner), send them to their tracker page; otherwise
 * (broker / carrier winner) send them to the broker dispatch page.
 */
export function dispatchLinkFor(
  recipientUserId: string | null | undefined,
  shipperUserId: string | null | undefined,
  loadId: string,
): string {
  if (recipientUserId && shipperUserId && recipientUserId === shipperUserId) {
    return shipperLoadLink(loadId);
  }
  return brokerDispatchLink(loadId);
}
